import { makeAutoObservable } from 'mobx'
import { type ISmartCallFlowCallEndsStep } from 'entities/SmartCall/api/types'
import { FlowActionStore } from 'widgets/Flow'
import {
  generateSmartCallActionId,
  type ISmartCallActionStore,
  type ISmartCallFlowActionStoreProps,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action'
import { type ISmartCallFlowActionType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type'

export type ICallEndsStoreProps = {
  id?: ISmartCallFlowActionStoreProps['id']
  parentId: ISmartCallFlowActionStoreProps['parentId']
}

export class CallEndsStore {
  static readonly type = 'callEnds' satisfies ISmartCallFlowActionType
  static title = 'Call ends'
  public readonly actionStore: ISmartCallActionStore

  constructor({ id, ...props }: ICallEndsStoreProps) {
    this.actionStore = new FlowActionStore({
      ...props,
      id: id || generateSmartCallActionId(`${this._stepIdType.type}_${this._stepIdType.id}`),
      type: CallEndsStore.type,
      name: CallEndsStore.title,
      defaultWidth: 48,
      defaultHeight: 32,
    })
    makeAutoObservable(this)
  }

  private _stepIdType: Pick<ISmartCallFlowCallEndsStep, 'id' | 'type'> = {
    id: 'success',
    type: 'result',
  }

  get step(): ISmartCallFlowCallEndsStep {
    return {
      ...this._stepIdType,
      next: this.actionStore.nextId,
    }
  }
}
